import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";
import queryString from 'query-string';
import * as constants from "../../../constants";
import { showLoading } from "../../../actions/action_loading";
import { changeFlagOldDonateInfo, confirmDonate } from "../../../actions/GochiKid/action_donate";
import { GOCHI_KID_PATH, PAYMENT_TYPE_STRIPE, PAYMENT_TYPE_VERITRANS } from "../../../constants";
import Payment from "../common/Payment";
import RadioInput from "../common/RadioInput";
import Header from "../layout/Header";
import DonateService from "../../../api/services/GochiKid/DonateService";
import { log, useCities, usePrefectures } from "../../../utils";
import ErrorAlert from "../common/ErrorAlert";
import ShopService from "../../../api/services/ShopService";
import { showError } from "../../../actions/action_error_alert";
import ActivityInfo from "../common/ActivityInfo";
import PaypayAd from "../../common/PaypayAd";
import { getPrefecturesSuccess } from "../../../actions/action_prefectures";
import { getCitiesSuccess } from "../../../actions/action_cities";
import PublicService from "../../../api/services/PublicService";
import { HTTP_API } from "../../../api/HttpClient";
import ChangeAmountWarningModal from "../common/ChangeAmountWarningModal";

const destinationChoicePath = `${constants.GOCHI_KID_PATH}/support/choice`;

function DonateInput({
  userInfo,
  paymentDefaultCard,
  showLoading,
  showError,
  confirmDonate,
  oldInput,
  savePrefectures,
  saveCities,
  prefectures,
  cities,
  changeFlagOldDonateInfo
}) {
  const history = useHistory();
  const match = useRouteMatch();
  const destination = match.params.destination;
  usePrefectures((list) => savePrefectures(list));
  useCities((list) => saveCities(list));

  const [loadingPayment, setLoadingPayment] = useState(false);
  const [loadingAvailableBillingGroup, setLoadingAvailableBillingGroup] = useState(false);
  const [loadingActivityInfo, setLoadingActivityInfo] = useState(false);
  const [loadingDonateInfo, setLoadingDonateInfo] = useState(false);
  const [activityInfo, setActivityInfo] = useState(null);
  const [userEmail, setUserEmail] = useState('');
  const [userName, setUserName] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [prefectureId, setPrefectureId] = useState('');
  const [prefectureName, setPrefectureName] = useState('');
  const [cityName, setCityName] = useState('');
  const [address, setAddress] = useState('');
  const [building, setBuilding] = useState('');
  const [paymentType, setPaymentType] = useState(null);
  const [isSubscription, setIsSubscription] = useState(true);
  const [billingGroupId, setBillingGroupId] = useState(null);
  const [donateAmount, setDonateAmount] = useState(null);
  const [donateMessage, setDonateMessage] = useState('');
  const [userEmailError, setUserEmailError] = useState('');
  const [userNameError, setUserNameError] = useState('');
  const [zipcodeError, setZipcodeError] = useState('');
  const [paymentTypeError, setPaymentTypeError] = useState('');
  const [donateAmountError, setDonateAmountError] = useState('');
  const [donateMessageError, setDonateMessageError] = useState('');
  const [useBankTransfer, setUseBankTransfer] = useState(false);
  const [showChangeAmountWarningModal, setShowChangeAmountWarningModal] = useState(false);
  const [warningBankTransferFlag, setWarningBankTransferFlag] = useState(false);
  const [disableBankTransfer, setDisableBankTransfer] = useState(true);

  const paymentTypeRef = useRef(null);
  const donateAmountRef = useRef(null);
  const userInfoRef = useRef(null);
  const filteredCities = cities.filter(city => Number(city.prefCode) === Number(prefectureId));

  const isSubscriptionDisabled = paymentType !== PAYMENT_TYPE_VERITRANS || !userInfo?.userId || (paymentDefaultCard && !billingGroupId);

  const getDestinationText = () => {
    switch (destination) {
      case 'region':
        return '都道府県';
      case 'activity':
        return '自治体/活動';
      default:
        return '全国';
    }
  };

  const warningBankTransfer = value => {
    if ((!value || value < 10000) && useBankTransfer) {
      setShowChangeAmountWarningModal(true);
      setDisableBankTransfer(true);
      setUseBankTransfer(false);
      setPaymentType(constants.PAYMENT_TYPE_CREDIT_CARD);
      return true;
    } else if (value >= 10000) {
      setDisableBankTransfer(false);
      return false;
    } else {
      setDisableBankTransfer(true);
      return false;
    }
  }

  const onChangeDonateAmount = (event) => {
    // Remove all non-digit characters
    setDonateAmount(parseInt(event.target.value.replace(/\D/g, '')) || null);
    setWarningBankTransferFlag(true);
    // let pattern = /^[0-9]+$/;
    // if (pattern.test(event.target.value)) {
    //   setDonateAmount(parseInt(event.target.value));
    // } else {
    //   setDonateAmount(null);
    // }
  };

  const onBlurDonateAmount = () => {
    setWarningBankTransferFlag(false);

    if (warningBankTransfer(donateAmount)) {
      document.getElementById('price-input').focus();
      window.scrollTo(0, 0);
    }
  }

  const onChoiceDonateAmount = (value) => {
    setDonateAmount(value);
    setWarningBankTransferFlag(false);
    warningBankTransfer(value);
  } 

  const onChangeDonateMessage = (event) => {
    setDonateMessage(event.target.value);
    setDonateMessageError(event.target.value?.length >= 200 ? '200文字以内ご入力ください。' : '');
  };

  const validateEmail = (email) => {
    return constants.EMAIL_REGEX.test(String(email).toLowerCase());
  };

  const getZipcode = async () => {
    const response = await PublicService.getZipcode(zipcode);

    if (response.status === HTTP_API.SUCCESS) {
      setPrefectureId(response.data.prefectureId || '');
      setPrefectureName(response.data.prefecture || '');
      setCityName(response.data.city || '');
      setAddress(response.data.address1);
    }
  }

  const validateZipcode = isGetData => {
    const value = zipcode?.trim();

    if (value && !/^\d{7}$/.test(value)) {
      setZipcodeError('0000000形式で入力してください。');
      return false;
    }

    setZipcodeError('');
    setZipcode(value);

    if (isGetData && value && !oldInput.haveOldDonateInfo) {
      getZipcode();
    }

    return true;
  }

  const validate = () => {
    let isValid = true;
    let firstErrorRef = null;
    setPaymentTypeError('');

    if (donateAmount && donateAmount > 0) {
      if (donateAmount <= 100000000) {
        setDonateAmountError('');
      } else {
        setDonateAmountError('一億円までご入力ください。');
        isValid = false;
      }
    } else {
      setDonateAmountError('数字を入力してください');
      isValid = false;
    }
    if (!isValid && !firstErrorRef) {
      firstErrorRef = donateAmountRef;
    }

    if (!paymentType) {
      isValid = false;
      setPaymentTypeError('お支払い方法を選択してください');

      if (!isValid && !firstErrorRef) {
        firstErrorRef = paymentTypeRef;
      }
    }

    if (userInfo?.userId) {
      if (paymentType === PAYMENT_TYPE_STRIPE || paymentType === PAYMENT_TYPE_VERITRANS) {
        if (!paymentDefaultCard) {
          setPaymentTypeError('お支払い方法を選択してください');
          isValid = false;
        }
      }
      if (!isValid && !firstErrorRef) {
        firstErrorRef = paymentTypeRef;
      }
    } else {
      if (userEmail?.trim?.()) {
        if (validateEmail(userEmail) && userEmail.length <= 255) {
          setUserEmailError('');
        } else {
          setUserEmailError('無効なメール形式');
          isValid = false;
        }
      } else {
        setUserEmailError('メールアドレスを入力してください。');
        isValid = false;
      }
    }

    if (userName?.trim?.()) {
      if (userName.length <= 50) {
        setUserNameError('');
      } else {
        setUserNameError('お名前を50文字以内で入力してください');
        isValid = false;
      }
    } else {
      setUserNameError('お名前を入力してください。')
      isValid = false;
    }

    if (!validateZipcode(false)) {
      isValid = false;
    }

    if (!isValid && !firstErrorRef) {
      firstErrorRef = userInfoRef;
    }

    if (firstErrorRef) {
      // firstErrorRef.current.scrollIntoView();
      window.scrollTo(0, 0);
    }

    return isValid;
  };

  const gotoConfirm = () => {
    if (!validate()) {
      return;
    }

    if (warningBankTransferFlag && warningBankTransfer(donateAmount)) {
      document.getElementById('price-input').focus();
      window.scrollTo(0, 0);
      return;
    }

    let data = {
      activityInfo,
      userEmail: userEmail?.trim() || '',
      userName: userName?.trim() || '',
      zipcode: zipcode?.trim() || '',
      prefectureId: prefectureId || '',
      prefectureName: prefectureName || '',
      cityName: cityName || '',
      address: address?.trim() || '',
      building: building?.trim() || '',
      paymentType,
      isSubscription: !isSubscriptionDisabled && isSubscription,
      billingGroupId,
      donateAmount,
      donateMessage: donateMessage?.trim() || ''
    };

    confirmDonate(data);
    history.push(
      `${GOCHI_KID_PATH}/support/choice/${destination}/confirm${window.location.search}`,
      { previousPath: window.location.pathname + window.location.search }
    );
  };

  const loadAvailableBillingGroup = async () => {
    if (!userInfo?.userId || !paymentDefaultCard || loadingAvailableBillingGroup || billingGroupId) {
      return;
    }
    setLoadingAvailableBillingGroup(true);
    const response = await DonateService.getAvailableBillingGroup();
    if (response.status === 200) {
      setBillingGroupId(response.data[0]);
    }
    setLoadingAvailableBillingGroup(false);
  }

  const loadShopInfo = async (shopId) => {
    setLoadingActivityInfo(true);
    const response = await ShopService.getDetailShop(shopId);
    if (response.status === 200) {
      setActivityInfo(response.data);
    } else {
      // TODO: error message
      showError(true, "インターネット接続には問題が発生しました。後でもう一度試してください。", "");
    }
    setLoadingActivityInfo(false);
  };

  const loadGroupInfo = async (groupId) => {
    setLoadingActivityInfo(true);
    const response = await ShopService.getDetailGroup(groupId);
    if (response.status === 200) {
      setActivityInfo(response.data);
    } else {
      // TODO: error message
      showError(true, "インターネット接続には問題が発生しました。後でもう一度試してください。", "");
    }
    setLoadingActivityInfo(false);
  };

  const getOldDonateInfo = async () => {
    setLoadingDonateInfo(true);
    const response = await DonateService.getDonateInfo();

    if (response.status === HTTP_API.SUCCESS) {
      const oldUserName = response.data.userName;
      const oldZipCode = response.data.zipCode;
      const oldPrefecture = response.data.prefecture;
      const oldPrefectureId = response.data.prefectureId;
      const oldCity = response.data.city;
      const oldAddress = response.data.address;
      const oldBuilding = response.data.building;
      setUserName(oldUserName);
      setZipcode(oldZipCode);
      setPrefectureName(oldPrefecture || '');
      setPrefectureId(oldPrefectureId || '');
      setCityName(oldCity || '');
      setAddress(oldAddress);
      setBuilding(oldBuilding);

      if (oldZipCode || oldPrefecture || oldPrefectureId || oldCity || oldAddress || oldBuilding) {
        changeFlagOldDonateInfo(true);
      } else {
        changeFlagOldDonateInfo(false);
      }
    } else {
      changeFlagOldDonateInfo(false);
      console.log(response.message);
    }

    setLoadingDonateInfo(false);
  }

  const closeWarningBankTransferModal = () => {
    setShowChangeAmountWarningModal(false);
    setWarningBankTransferFlag(false);
  }

  useEffect(() => {
    loadAvailableBillingGroup();
  }, [paymentDefaultCard]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    showLoading(loadingPayment || loadingAvailableBillingGroup || loadingActivityInfo || loadingDonateInfo);
  }, [loadingPayment, loadingAvailableBillingGroup, loadingActivityInfo, loadingDonateInfo]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    log('DonateInput componentDidMount');

    if (oldInput.donateAmount) {
      setDonateAmount(oldInput.donateAmount);
      setPaymentType(oldInput.paymentType);
      setIsSubscription(oldInput.isSubscription);
      setUserEmail(oldInput.userEmail);
      setUserName(oldInput.userName);
      setZipcode(oldInput.zipcode);
      setPrefectureId(oldInput.prefectureId);
      setPrefectureName(oldInput.prefectureName);
      setCityName(oldInput.cityName);
      setAddress(oldInput.address);
      setBuilding(oldInput.building);
      setDonateMessage(oldInput.donateMessage);
    } else if (userInfo?.userId) {
      getOldDonateInfo();
    }

    // get shop/group ID from url params and validate
    const params = queryString.parse(window.location.search);
    switch (destination) {
      case 'national':
        // Donate national do not require shopId/groupId
        confirmDonate({
          destination
        });
        break;
      case 'region':
        if (params.donateGroupId && parseInt(params.donateGroupId, 10) > 0) {
          confirmDonate({
            destination,
            groupId: parseInt(params.donateGroupId, 10)
          });
          loadGroupInfo(parseInt(params.donateGroupId, 10));
        } else {
          history.replace(destinationChoicePath + '?skipPolicyCheck=true');
          return;
        }
        break;
      case 'activity':
        if (params.donateShopId && parseInt(params.donateShopId, 10) > 0) {
          confirmDonate({
            destination,
            shopId: parseInt(params.donateShopId, 10)
          });
          loadShopInfo(parseInt(params.donateShopId, 10));
        } else if (params.donateGroupId && parseInt(params.donateGroupId, 10) > 0) {
          confirmDonate({
            destination,
            groupId: parseInt(params.donateGroupId, 10)
          });
          loadGroupInfo(parseInt(params.donateGroupId, 10));
        } else {
          history.replace(destinationChoicePath + '?skipPolicyCheck=true');
          return;
        }
        break;
      default:
        history.replace(destinationChoicePath + '?skipPolicyCheck=true');
        return;
    }

    window.scrollTo(0, 0);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Header />

      <main className="page-wrapper">
        <div className="page-content donate-payment">

          <div className="font-family-rounded title-donate text-center color-2F1A1C mb-3">支援内容の入力</div>
          <ul className="payment-progress-bar align-center">
            <li className="active">入力</li>
            <li>確認</li>
            <li>完了</li>
          </ul>

          <div className="fs-14px fw-400">
            <span className="color-ED808C fs-20px fw-700">*</span>
            ：必須入力ですので、必ずご入力お願い致します
          </div>

          {(donateAmountError || paymentTypeError || userEmailError || userNameError) && <ErrorAlert className="mt-3">
            <div>
              以下の入力項目に誤りがあります。エラーメッセージをご確認頂き、再度ご入力をお願い致します。
            </div>
            <ul>
              {donateAmountError && <li>金額（税込）</li>}
              {paymentTypeError && <li>お支払い方法</li>}
              {(userEmailError || userNameError) && <li>支援者情報</li>}
            </ul>
          </ErrorAlert>}

          <div className="block-title-lg font-family-rounded mt-5">
            支援先 <span className="color-ED808C">*</span>：{getDestinationText()}
          </div>

          {activityInfo && <div className="mt-3">
            <ActivityInfo
              className="activity-info-confirm"
              info={activityInfo}
              hideContactInfo={destination === 'region'}
            />
          </div>}

          <div ref={donateAmountRef} className="block-title-lg font-family-rounded mt-5">
            金額
          </div>
          <div className="fs-14px fw-700 mt-3">金額選択</div>
          <div className="mt-2">
            <button
              className={'btn-outline btn-donate-amount-preset' + (donateAmount === 10000 ? ' background-FBEBEC' : '')}
              onClick={() => onChoiceDonateAmount(10000)}
            >{Number(10000).toLocaleString()}<span className="fs-16px">円</span></button>
            <button
              className={'btn-outline btn-donate-amount-preset ml-3' + (donateAmount === 2000 ? ' background-FBEBEC' : '')}
              onClick={() => onChoiceDonateAmount(2000)}
            >{Number(2000).toLocaleString()}<span className="fs-16px">円</span></button>
            <button
              className={'btn-outline btn-donate-amount-preset ml-3' + (donateAmount === 1000 ? ' background-FBEBEC' : '')}
              onClick={() => onChoiceDonateAmount(1000)}
            >{Number(1000).toLocaleString()}<span className="fs-16px">円</span></button>
          </div>
          <div className="fs-14px fw-700 mt-4">指定金額 <span className="color-ED808C">*</span></div>
          <div className="d-flex align-items-center mt-1">
            <input
              id="price-input"
              className="form-control text-right outline-none"
              placeholder="金額をご入力ください"
              type="tel"
              inputMode="numeric"
              value={donateAmount || ''}
              onChange={onChangeDonateAmount}
              onBlur={() => onBlurDonateAmount()}
              autoComplete="off"
            />
            <span className="ml-3 fw-700">円</span>
          </div>
          {donateAmountError && <ErrorAlert className="mt-2">{donateAmountError}</ErrorAlert>}

          <div className="block-title-lg font-family-rounded mt-5">
            回数 <span className="color-ED808C">*</span>
          </div>
          <div className="d-flex mt-3">
            <RadioInput
              disabled={isSubscriptionDisabled}
              className="mr-2"
              inputName="isSubscription"
              inputValue="true"
              checked={!isSubscriptionDisabled && isSubscription}
              onChange={(e) => setIsSubscription(e.target.value === 'true')}
            >継続（1ヶ月1回）</RadioInput>
            <RadioInput
              className="ml-4"
              inputName="isSubscription"
              inputValue="false"
              checked={isSubscriptionDisabled || !isSubscription}
              onChange={(e) => setIsSubscription(e.target.value === 'true')}
            >一度だけ</RadioInput>
          </div>

          {/*<PaypayAd className="logo-paypay-ad-donate" />*/}

          {!userInfo?.userId && <div className="payment-note mt-3">
            <div className="payment-note-icon">
              <svg width="5" height="18" viewBox="0 0 5 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.56366 18C2.05762 18 1.62574 17.8292 1.26802 17.4875C0.910304 17.1458 0.731445 16.7333 0.731445 16.25C0.731445 15.7667 0.910304 15.3542 1.26802 15.0125C1.62574 14.6708 2.05762 14.5 2.56366 14.5C3.0697 14.5 3.50158 14.6708 3.8593 15.0125C4.21702 15.3542 4.39587 15.7667 4.39587 16.25C4.39587 16.7333 4.21702 17.1458 3.8593 17.4875C3.50158 17.8292 3.0697 18 2.56366 18ZM2.56366 12C2.05762 12 1.62574 11.8292 1.26802 11.4875C0.910304 11.1458 0.731445 10.7333 0.731445 10.25V1.75C0.731445 1.26667 0.910304 0.854167 1.26802 0.5125C1.62574 0.170833 2.05762 0 2.56366 0C3.0697 0 3.50158 0.170833 3.8593 0.5125C4.21702 0.854167 4.39587 1.26667 4.39587 1.75V10.25C4.39587 10.7333 4.21702 11.1458 3.8593 11.4875C3.50158 11.8292 3.0697 12 2.56366 12Z" fill="#47ACFF"/>
              </svg>
            </div>
            <div className="payment-note-text">
              継続（1ヶ月1回）のご支援は、会員登録とログインをした場合にのみご利用可能です。
            </div>
          </div>}

          <div ref={paymentTypeRef} className="block-title-lg font-family-rounded mt-5">
            お支払い方法 <span className="color-ED808C">*</span>
          </div>
          <Payment
            className="mt-3"
            paymentType={paymentType}
            disabledNonSubscription={!isSubscriptionDisabled && isSubscription}
            setPaymentType={setPaymentType}
            paymentTypeError={paymentTypeError}
            loading={loadingPayment}
            setLoading={setLoadingPayment}
            disableBankTransfer={disableBankTransfer}
            setDisableBankTransfer={setDisableBankTransfer}
            useBankTransfer={useBankTransfer}
            setUseBankTransfer={setUseBankTransfer}
          />

          {!isSubscriptionDisabled && isSubscription && <div className="payment-note mt-3">
            <div className="payment-note-icon">
              <svg width="5" height="18" viewBox="0 0 5 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.56366 18C2.05762 18 1.62574 17.8292 1.26802 17.4875C0.910304 17.1458 0.731445 16.7333 0.731445 16.25C0.731445 15.7667 0.910304 15.3542 1.26802 15.0125C1.62574 14.6708 2.05762 14.5 2.56366 14.5C3.0697 14.5 3.50158 14.6708 3.8593 15.0125C4.21702 15.3542 4.39587 15.7667 4.39587 16.25C4.39587 16.7333 4.21702 17.1458 3.8593 17.4875C3.50158 17.8292 3.0697 18 2.56366 18ZM2.56366 12C2.05762 12 1.62574 11.8292 1.26802 11.4875C0.910304 11.1458 0.731445 10.7333 0.731445 10.25V1.75C0.731445 1.26667 0.910304 0.854167 1.26802 0.5125C1.62574 0.170833 2.05762 0 2.56366 0C3.0697 0 3.50158 0.170833 3.8593 0.5125C4.21702 0.854167 4.39587 1.26667 4.39587 1.75V10.25C4.39587 10.7333 4.21702 11.1458 3.8593 11.4875C3.50158 11.8292 3.0697 12 2.56366 12Z" fill="#47ACFF"/>
              </svg>
            </div>
            <div className="payment-note-text">
              「クレジットカードで決済」以外のお支払い方法は、支援回数を一度だけに設定された方限定でご利用可能です。また、「銀行振込」は1万円以上のご寄付からお選びいただけます。
            </div>
          </div>}

          <div ref={userInfoRef} className="block-title-lg font-family-rounded mt-5">
            支援者情報
          </div>
          <div className="payment-note mt-3">
            <div className="payment-note-icon">
              <svg width="5" height="18" viewBox="0 0 5 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.56366 18C2.05762 18 1.62574 17.8292 1.26802 17.4875C0.910304 17.1458 0.731445 16.7333 0.731445 16.25C0.731445 15.7667 0.910304 15.3542 1.26802 15.0125C1.62574 14.6708 2.05762 14.5 2.56366 14.5C3.0697 14.5 3.50158 14.6708 3.8593 15.0125C4.21702 15.3542 4.39587 15.7667 4.39587 16.25C4.39587 16.7333 4.21702 17.1458 3.8593 17.4875C3.50158 17.8292 3.0697 18 2.56366 18ZM2.56366 12C2.05762 12 1.62574 11.8292 1.26802 11.4875C0.910304 11.1458 0.731445 10.7333 0.731445 10.25V1.75C0.731445 1.26667 0.910304 0.854167 1.26802 0.5125C1.62574 0.170833 2.05762 0 2.56366 0C3.0697 0 3.50158 0.170833 3.8593 0.5125C4.21702 0.854167 4.39587 1.26667 4.39587 1.75V10.25C4.39587 10.7333 4.21702 11.1458 3.8593 11.4875C3.50158 11.8292 3.0697 12 2.56366 12Z" fill="#47ACFF"/>
              </svg>
            </div>
            <div className="payment-note-text">
              NPO法人 Kids Future Passport は、より多くの子どもたちに支援を届けるため、「認定NPO法人」の取得を目指しております。
              <br />
              この認定を受けるためには、ご寄付をいただく際に 寄付者さまの<span className="text-red">情報のご登録</span>が必要となります。
              <br />
              <span className="text-red">お預かりした個人情報は厳重に管理し、認定手続き以外の目的には使用いたしません。</span>
              <br />
              皆さまのご理解とご協力を心よりお願い申し上げます。
            </div>
          </div>

          {!userInfo?.userId && <>
            <div className="fs-14px fw-700 color-2F1A1C mt-4">
              メールアドレス <span className="color-ED808C">*</span>
            </div>
            <div className="mt-1">
              <input
                className="form-control"
                placeholder="例）kodomo.gochimeshi@gigi.tokyo"
                type="email"
                value={userEmail || ''}
                onChange={(event) => setUserEmail(event.target.value)}
              />
            </div>
            {userEmailError && <ErrorAlert className="mt-2">{userEmailError}</ErrorAlert>}
            <div className="payment-warning mt-2">
              <div className="payment-warning-icon">
                <svg width="25" height="24" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.68036 21.1482H20.4479C22.0602 21.1482 23.0653 19.4782 22.2591 18.1482L14.3754 5.13825C13.5692 3.80825 11.559 3.80825 10.7528 5.13825L2.86908 18.1482C2.06291 19.4782 3.06801 21.1482 4.68036 21.1482ZM12.5641 14.1482C11.9883 14.1482 11.5171 13.6982 11.5171 13.1482V11.1482C11.5171 10.5982 11.9883 10.1482 12.5641 10.1482C13.14 10.1482 13.6111 10.5982 13.6111 11.1482V13.1482C13.6111 13.6982 13.14 14.1482 12.5641 14.1482ZM13.6111 18.1482H11.5171V16.1482H13.6111V18.1482Z" fill="#F9AC39"/>
                </svg>
              </div>
              <div className="payment-warning-text">
                寄付に関する重要なお知らせやお問合わせへの対応のため、メールアドレスの登録をお願いしております。
              </div>
            </div>
          </>}

          <div className="fs-14px fw-700 color-2F1A1C mt-4">
            氏名 <span className="color-ED808C">*</span>
          </div>
          <div className="mt-1">
            <input
              id="username-input"
              className="form-control"
              placeholder="支援者様の氏名をご入力ください"
              type="text"
              value={userName || ''}
              onChange={(event) => setUserName(event.target.value)}
              autoComplete="off"
            />
          </div>
          {userNameError && <ErrorAlert className="mt-2">{userNameError}</ErrorAlert>}
          <div className="fs-14px fw-700 color-2F1A1C mt-4">
            郵便番号※ハイフンなし
          </div>
          <div className="mt-1">
            <input
              id="number-prefecture-input"
              className="form-control"
              placeholder="1234567"
              type="text"
              value={zipcode || ''}
              onChange={(event) => setZipcode(event.target.value)}
              onBlur={() => validateZipcode(true)}
              autoComplete="off"
            />
          </div>
          {zipcodeError && <ErrorAlert className="mt-2">{zipcodeError}</ErrorAlert>}
          <div className="fs-14px fw-700 color-2F1A1C mt-4">
            都道府県
          </div>
          <div className="mt-1">
            <select
              id="prefecture-select"
              className="select-round form-control select-control"
              value={prefectureId}
              onChange={(e) => {
                setPrefectureId(e.target.value);
                setCityName('');
                if (e.target.value) {
                  const index = e.nativeEvent.target.selectedIndex;
                  const label = e.nativeEvent.target[index].text;
                  setPrefectureName(label);
                } else {
                  setPrefectureName('');
                }
              }}
              autoComplete="off"
            >
              <option value="">都道府県</option>
              {prefectures.map(item =>
                <option key={item.prefectureId} value={item.prefectureId}>{item.prefectureName}</option>
              )}
            </select>
          </div>
          <div className="fs-14px fw-700 color-2F1A1C mt-4">
            市区町村
          </div>
          <div className="mt-1">
            <select
              id="city-select"
              className="select-round form-control select-control"
              value={cityName}
              onChange={(e) => {
                if (e.target.value) {
                  const index = e.nativeEvent.target.selectedIndex;
                  const label = e.nativeEvent.target[index].text;
                  setCityName(label);
                } else {
                  setCityName('');
                }
              }}
              autoComplete="off"
            >
              <option value="">市区町村</option>
              {filteredCities.map(item =>
                <option key={item.cityId} value={item.cityName}>{item.cityName}</option>
              )}
            </select>
          </div>
          <div className="fs-14px fw-700 color-2F1A1C mt-4">
            町域・番地
          </div>
          <div className="mt-1">
            <input
              id="address-input"
              className="form-control"
              placeholder="町域・番地"
              type="text"
              value={address || ''}
              onChange={(event) => setAddress(event.target.value)}
              autoComplete="off"
            />
          </div>
          <div className="fs-14px fw-700 color-2F1A1C mt-4">
            建物名
          </div>
          <div className="mt-1">
            <input
              id="building-input"
              className="form-control"
              placeholder="建物名"
              type="text"
              value={building || ''}
              onChange={(event) => setBuilding(event.target.value)}
              autoComplete="off"
            />
          </div>

          <div className="block-title-lg font-family-rounded mt-5">
            こども達へのメッセージ<span className="color-35A99E"></span>
          </div>
          <div className="mt-3">
            <textarea
              className="donate-message"
              placeholder="200文字以内で支援先への応援メッセージをご入力ください。"
              maxLength={200}
              value={donateMessage}
              onChange={onChangeDonateMessage}
            />
          </div>
          {donateMessageError && <ErrorAlert className="mt-2">{donateMessageError}</ErrorAlert>}
          <div className="payment-note mt-3">
            <div className="payment-note-icon">
              <svg width="5" height="18" viewBox="0 0 5 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.56366 18C2.05762 18 1.62574 17.8292 1.26802 17.4875C0.910304 17.1458 0.731445 16.7333 0.731445 16.25C0.731445 15.7667 0.910304 15.3542 1.26802 15.0125C1.62574 14.6708 2.05762 14.5 2.56366 14.5C3.0697 14.5 3.50158 14.6708 3.8593 15.0125C4.21702 15.3542 4.39587 15.7667 4.39587 16.25C4.39587 16.7333 4.21702 17.1458 3.8593 17.4875C3.50158 17.8292 3.0697 18 2.56366 18ZM2.56366 12C2.05762 12 1.62574 11.8292 1.26802 11.4875C0.910304 11.1458 0.731445 10.7333 0.731445 10.25V1.75C0.731445 1.26667 0.910304 0.854167 1.26802 0.5125C1.62574 0.170833 2.05762 0 2.56366 0C3.0697 0 3.50158 0.170833 3.8593 0.5125C4.21702 0.854167 4.39587 1.26667 4.39587 1.75V10.25C4.39587 10.7333 4.21702 11.1458 3.8593 11.4875C3.50158 11.8292 3.0697 12 2.56366 12Z" fill="#47ACFF"/>
              </svg>
            </div>
            <div className="payment-note-text">
              いただいたメッセージは、匿名で当団体が発信する「寄付通信」やSNSに使用させていただくことがあります。
            </div>
          </div>
          <div className="mt-5">
            <button className="btn-primary btn-size-md w-100" onClick={gotoConfirm}>
              次へ進む
              <i className="icon-next-destination" />
            </button>
          </div>
          <div className="mt-4 text-center">
            <button className="btn-link fw-400 border-0 p-0" onClick={() => history.replace(destinationChoicePath + '?skipPolicyCheck=true')}>
              前の画面に戻る
            </button>
          </div>

        </div>
      </main>

      <ChangeAmountWarningModal
        show={showChangeAmountWarningModal}
        handleClose={() => closeWarningBankTransferModal()} 
      />
    </>
  );
}

const mapStateToProps = state => ({
  userInfo: state.userInfo,
  paymentDefaultCard: !state.paymentMethod || state.paymentMethod.length === 0 ? null : state.paymentMethod,
  oldInput: state.gochiKid.donate,
  prefectures: state.prefectures,
  cities: state.cities
});

const mapDispatchToProps = dispatch => ({
  showLoading: (showing) => dispatch(showLoading(showing)),
  showError: (showing, title, content, buttonName, gotoUrl) => dispatch(showError(showing, title, content, buttonName, gotoUrl)),
  confirmDonate: (paymentData) => dispatch(confirmDonate(paymentData)),
  savePrefectures: (list) => dispatch(getPrefecturesSuccess(list)),
  saveCities: (list) => dispatch(getCitiesSuccess(list)),
  changeFlagOldDonateInfo: (haveOldDonateInfo) => dispatch(changeFlagOldDonateInfo(haveOldDonateInfo)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DonateInput);
